import { deserialize } from '@ungap/structured-clone';
import { BoneSide } from '../../../../anatomy/bone-side.js';
import { GetAllMuscles } from '../../../../anatomy/get-all-muscles.js';
import { uuidV4 } from '../../../../util/others/uuid-v4.js';
import { dtoToRgObject } from '../../dto-to-rg-object.js';

const dtoToBuilding = (dto, versions) => {
    const anatomy = deserialize(dto.data.anatomy);
    // upgrade from `muscle.flip` to `muscle.side`
    if (anatomy) {
        const muscles = GetAllMuscles(anatomy);
        for (const m of muscles) {
            // upgrade `Muscle.flip` replaced by `Muscle.side`
            if (m.flip)
                m.side = BoneSide.Left;
            if (m.side !== BoneSide.Left)
                m.side = BoneSide.Right;
        }
    }
    /**
     * `LevelData.id` has been replaced by a combination of `uuid` and `levelIndex`
     */
    const levels = dto.data.levels.map(lvl => {
        if (!lvl.uuid)
            lvl.uuid = uuidV4();
        if ('id' in lvl) {
            lvl.levelIndex = lvl.id;
            const levelChildren = dto.children.filter(child => 'level' in child.data && child.data.level === lvl.levelIndex);
            for (const child of levelChildren) {
                child.data.levelId = lvl.uuid;
            }
            delete lvl.id;
        }
        if (lvl.isRoof && lvl.geaPolygon) {
            lvl.roofFacadePerimeter = [lvl.geaPolygon];
            delete lvl.geaPolygon;
        }
        if (lvl.isRoof && lvl.giaPolygon) {
            delete lvl.giaPolygon;
        }
        return lvl;
    });
    const data = {
        ...dto.data,
        levels,
        anatomy
    };
    /** children uuids that only exist in muscle */
    const muscleChildrenDto = new Set();
    for (const child of dto.children) {
        if (!child.data.dtoMuscleUnit)
            continue;
        muscleChildrenDto.add(child.uuid);
    }
    const building = dtoToRgObject(dto, { versions, partials: { data }, top: false });
    const units = new Map(building.children.map(c => [c.uuid, c]));
    const muscles = GetAllMuscles(building.data.anatomy);
    // revert back muscles to their original form
    for (let i = 0; i < muscles.length; i++) {
        const muscle = muscles[i];
        if (!muscle.gFUnitsIds)
            continue;
        muscle.gFUnits = muscle.gFUnitsIds.map(id => units.get(id));
        delete muscles[i].gFUnitsIds;
    }
    // remove muscle units from building.children
    const children = building.children.slice();
    for (let i = 0; i < children.length; i++) {
        if (!muscleChildrenDto.has(children[i].uuid))
            continue;
        delete children[i].data.dtoMuscleUnit;
        children.splice(i, 1);
        i--;
    }
    building.children = children;
    return building;
};

export { dtoToBuilding };
//# sourceMappingURL=dto-to-building.js.map
